import UserApi from "@/api/user";
import ProjectApi from "@/api/project";
import ServiceApi from "@/api/service";
import AlertApi from "@/api/alert";
import AlertRuleApi from "@/api/alertRule";
import UserGroupApi from "@/api/userGroup";
import MessageApi from "@/api/message";
import TeamApi from "@/api/team";


export const Apis = {
    User: new UserApi(),
    Project: new ProjectApi(),
    Service: new ServiceApi(),
    Alert: new AlertApi(),
    AlertRule: new AlertRuleApi(),
    UserGroup: new UserGroupApi(),
    Message: new MessageApi(),

    Team: new TeamApi()
}